import { render, staticRenderFns } from "./AboutScopesButton.vue?vue&type=template&id=2f799f8c"
import script from "./AboutScopesButton.vue?vue&type=script&lang=js"
export * from "./AboutScopesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports